document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const scrim = q('[data-drawer-scrim]');
  const cartDrawer = q('[data-cart-drawer]');
  const menu = q('[data-mobile-menu]');
  const search = q('[data-search-overlay]');

  const closeAll = () => {
    [cartDrawer, menu, search, scrim].forEach((element) => element?.classList.remove('open'));
    [cartDrawer, menu, search].forEach((element) => element?.setAttribute('aria-hidden', 'true'));
    body.classList.remove('drawer-open');
  };

  const openPanel = (element) => {
    closeAll();
    element?.classList.add('open');
    element?.setAttribute('aria-hidden', 'false');
    scrim?.classList.add('open');
    body.classList.add('drawer-open');
  };

  q('[data-menu-toggle]')?.addEventListener('click', () => openPanel(menu));
  q('[data-menu-close]')?.addEventListener('click', closeAll);
  q('[data-search-toggle]')?.addEventListener('click', () => openPanel(search));
  q('[data-search-close]')?.addEventListener('click', closeAll);
  q('[data-cart-toggle]')?.addEventListener('click', () => { openPanel(cartDrawer); renderCart(); });
  q('[data-cart-close]')?.addEventListener('click', closeAll);
  scrim?.addEventListener('click', closeAll);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });

  const footerAccordions = qa('.footer-accordion');
  let desktopFooter;
  const syncFooterAccordions = () => {
    const isDesktop = window.innerWidth > 900;
    if (isDesktop === desktopFooter) return;
    footerAccordions.forEach((details) => { details.open = isDesktop; });
    desktopFooter = isDesktop;
  };
  syncFooterAccordions();
  window.addEventListener('resize', syncFooterAccordions, { passive: true });

  const money = (cents) => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(cents / 100);

  async function renderCart() {
    const root = q('[data-cart-content]');
    if (!root) return;
    const cart = await fetch('/cart.js').then((response) => response.json());
    qa('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
    const remaining = Math.max(0, 79900 - cart.total_price);
    const percentage = Math.min(100, cart.total_price / 79900 * 100);

    if (!cart.items.length) {
      root.innerHTML = '<p>Your cart is empty.</p><a class="button primary" href="/collections/all">Continue shopping</a>';
      return;
    }

    root.innerHTML = `
      <div class="shipping-progress">
        <p>${remaining ? `${money(remaining)} away from free shipping` : 'You have unlocked free shipping'}</p>
        <div class="progress-track"><div class="progress-fill" style="width:${percentage}%"></div></div>
      </div>
      ${cart.items.map((item) => `
        <div class="drawer-item">
          <img src="${item.image}" alt="">
          <div><h3>${item.product_title}</h3><p>${item.variant_title || ''}</p><p>${item.quantity} × ${money(item.final_price)}</p></div>
          <button class="drawer-remove" data-remove-key="${item.key}">Remove</button>
        </div>`).join('')}
      <div class="drawer-total"><span>Estimated total</span><span>${money(cart.total_price)}</span></div>
      <p>COD available · Taxes and shipping calculated at checkout</p>
      <div class="drawer-actions"><a class="button primary" href="/checkout">Checkout</a><a class="button secondary" href="/collections/all">Continue shopping</a></div>`;

    qa('[data-remove-key]', root).forEach((button) => button.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.removeKey, quantity: 0 })
      });
      renderCart();
    }));
  }

  const productForm = q('[data-product-form]');
  if (productForm) {
    q('[data-qty-minus]')?.addEventListener('click', () => {
      const input = q('[data-qty]');
      input.value = Math.max(1, Number(input.value) - 1);
    });
    q('[data-qty-plus]')?.addEventListener('click', () => {
      const input = q('[data-qty]');
      input.value = Number(input.value) + 1;
    });
    q('[data-variant-select]')?.addEventListener('change', (event) => {
      const price = event.target.selectedOptions[0].dataset.price;
      q('[data-product-price]').textContent = price;
      q('[data-sticky-price]')?.replaceChildren(document.createTextNode(price));
    });
    const ajaxAdd = q('[data-ajax-add]', productForm);
    ajaxAdd?.addEventListener('click', async (event) => {
      event.preventDefault();
      ajaxAdd.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm) });
        if (!response.ok) throw new Error('Unable to add this pack to cart.');
        openPanel(cartDrawer);
        await renderCart();
      } finally {
        ajaxAdd.disabled = false;
      }
    });
    q('[data-sticky-add]')?.addEventListener('click', () => ajaxAdd?.click());
  }


  qa('[data-card-buy-form]').forEach((form) => {
    const variant = q('[data-card-variant]', form);
    const quantity = q('[data-card-qty]', form);
    const card = form.closest('.direct-buy-card');
    const price = q('[data-card-price]', card);
    const addButton = q('[data-card-add]', form);
    q('[data-card-minus]', form)?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    q('[data-card-plus]', form)?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });
    variant?.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton) return;
      addButton.disabled = true;
      const originalText = addButton.textContent;
      addButton.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add this pack to cart.');
        window.location.assign('/cart');
      } catch (error) {
        addButton.textContent = 'Try again';
        window.setTimeout(() => { addButton.textContent = originalText; addButton.disabled = false; }, 1600);
      }
    });
  });

  let timer;
  const input = q('[data-predictive-search]');
  const results = q('[data-search-results]');
  input?.addEventListener('input', () => {
    clearTimeout(timer);
    const term = input.value.trim();
    if (term.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(async () => {
      const data = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`).then((response) => response.json());
      const products = data.resources.results.products || [];
      results.innerHTML = products.map((product) => `<a class="predictive-result" href="${product.url}">${product.image ? `<img src="${product.image}" alt="">` : ''}<span><strong>${product.title}</strong><br>${product.price}</span></a>`).join('') || '<p>No products found.</p>';
    }, 250);
  });
});
